import { giphyDarkestGrey } from '@giphy/colors'
import styled from 'styled-components'
import { ControlSize } from 'types'
import { borderRadiusFromControlSize, heightFromControlSize } from 'utils'
import HeaderComponent from './header'

export const Header = styled(HeaderComponent)`
    border-radius: inherit;
    position: relative;
    user-select: none;
`

export const Container = styled.div<{ controlSize: ControlSize }>`
    background: ${giphyDarkestGrey};
    border-radius: ${({ controlSize }) => borderRadiusFromControlSize(controlSize)}px;

    ${Header} {
        min-height: ${({ controlSize }) => heightFromControlSize(controlSize)}px;
    }
`
